export default __webpack_public_path__ + "static/media/home-digital-agency-img-03.9b08ec50.jpg";